/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CountryCode } from './CountryCode';
import {
    CountryCodeFromJSON,
    CountryCodeFromJSONTyped,
    CountryCodeToJSON,
    CountryCodeToJSONTyped,
} from './CountryCode';

/**
 * 
 * @export
 * @interface AddressDraft
 */
export interface AddressDraft {
    /**
     * 
     * @type {string}
     * @memberof AddressDraft
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDraft
     */
    stateOrProvinceCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDraft
     */
    postalCode?: string;
    /**
     * 
     * @type {CountryCode}
     * @memberof AddressDraft
     */
    countryCode?: CountryCode;
    /**
     * 
     * @type {string}
     * @memberof AddressDraft
     */
    addressLine?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDraft
     */
    addressLine2?: string;
}



/**
 * Check if a given object implements the AddressDraft interface.
 */
export function instanceOfAddressDraft(value: object): value is AddressDraft {
    return true;
}

export function AddressDraftFromJSON(json: any): AddressDraft {
    return AddressDraftFromJSONTyped(json, false);
}

export function AddressDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'city': json['city'] == null ? undefined : json['city'],
        'stateOrProvinceCode': json['stateOrProvinceCode'] == null ? undefined : json['stateOrProvinceCode'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'countryCode': json['countryCode'] == null ? undefined : CountryCodeFromJSON(json['countryCode']),
        'addressLine': json['addressLine'] == null ? undefined : json['addressLine'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
    };
}

  export function AddressDraftToJSON(json: any): AddressDraft {
      return AddressDraftToJSONTyped(json, false);
  }

  export function AddressDraftToJSONTyped(value?: AddressDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'city': value['city'],
        'stateOrProvinceCode': value['stateOrProvinceCode'],
        'postalCode': value['postalCode'],
        'countryCode': CountryCodeToJSON(value['countryCode']),
        'addressLine': value['addressLine'],
        'addressLine2': value['addressLine2'],
    };
}

